if(window.PUBLIC_PATH != '') {
	__webpack_public_path__ = window.PUBLIC_PATH;
}
